module.exports = __webpack_public_path__ + "img/app-store.e64471c2.png";